<script setup>
defineProps({
  lookup: Object
});
</script>

<template>
  <table class="w-full table-fixed">
    <thead>
      <tr>
        <th class="w-2/12 pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_cname.rdtype') }}
        </th>
        <th class="w-1/12 pb-3 text-left" scope="col">TTL</th>
        <th class="pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_cname.target') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>CNAME</td>
        <td>{{ lookup.ttl }}</td>
        <td>
          {{ lookup.cname }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
